import React from 'react';
var Defs = _ref => {
  var {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("defs", null, children);
};
export default Defs;
//# sourceMappingURL=index.js.map